import Curl from '$common/utils/curl/browser-curl';
import UrlModules from '$common/utils/curl/browser-curl/url-modules';
import { gateway_web as pix } from '../api-pix';

const appgatewayHost = new UrlModules({ module: 'appgateway' });
const defaultCurl = (params, url, config) => new Curl().curl(params, `${appgatewayHost.host}/${pix}/${url}`, config);

/**
 * 查询门店详情
 * @param {*} params
 */
export const getGroupbuyStoreDetail = (params, config) => defaultCurl(params, `groupon-service/app/H5/store/info`, config);

/**
 * 查询门店推荐产品
 * @param params
 * @param config
 */
export const queryStoreRecommendProduct = (params, config) => defaultCurl(params, 'groupon-service/app/H5/store/commend/product/list', config);
